import '../../../css/supervisorcontrolls/supervisormenu.css';
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { SelectBox } from 'devextreme-react/select-box';
import useMonitorAPIService from '../../../services/monitorapiservice';
import ChatService from 'src/services/chatservice';

function TransferList(props) {


    const { t } = useTranslation();
    const { getSupervisedAgents, transferCallToAgent } = useMonitorAPIService();

    const wrapperRef = useRef(null);
    const [userId, setUserId] = useState(null);
    const [agents, setAgents] = useState([]);

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (props.showTransferList && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                //props.toggleTransferList();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        if (props.showTransferList) {

            getSupervisedAgents(props.token, (res) => {
                setAgents(res.data);
            });
        }

        //UNMOUNT
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showTransferList]);

    const handleChange = (value) => {

        let agent = agents.find(x => x.userId === value);
        if (agent) {
            setUserId(value);
        }
    }

    const handleSend = (e) => {
        e.preventDefault();
        if (props.type === 'call') {
            var callToTransfer = {
                ext: props.call.ext !== null && props.call.ext.trim() !== "" ? props.call.ext : props.call.portExt,
                callId: props.call.id,
                pin: userId,
                status: props.call.status,
                forceTransfer: false
            };

            transferCallToAgent(props.token, callToTransfer, e => {
                props.toggleTransferList();
            });

        } else {

            ChatService.transferChat(userId, null, props.call.conversationId, e => {
                props.toggleTransferList();
            });
            
        }
    }

    return (

        <div ref={wrapperRef} className={"position-fixed menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-250px " + (props.showTransferList ? "show" : "")}>
            <div className="menu-item px-5">
                <div className="mb-10">
                    <label className="form-label fw-semibold">{t("agent")}</label>
                    <div>
                        <SelectBox
                            dataSource={agents.map(x => { return { id: x.userId, name: x.fullName } })}
                            value={userId}
                            onValueChange={handleChange}
                            valueExpr="id"
                            displayExpr="name"
                            searchEnabled={true}
                            dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                        />
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end">
                <button type="reset" className="btn btn-sm btn-light btn-active-light-primary me-2" onClick={e => { e.preventDefault(); props.toggleTransferList(); }}>{t("close")}</button>
                <button type="submit" className="btn btn-sm btn-primary" onClick={handleSend}>{t("send")}</button>
            </div>
        </div>

    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
    };
};

export default connect(mapStateToProps, {})(TransferList);
